import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../../';
import { ContextConsumer } from './Context';
import { withNavDropdownEvents, NavDropdown } from './NavDropdown';
import NavItem from './NavItem';

var CompactNav = /*#__PURE__*/function (_React$Component) {
  _inherits(CompactNav, _React$Component);

  var _super = _createSuper(CompactNav);

  function CompactNav() {
    var _this;

    _classCallCheck(this, CompactNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // currently expanded submenus
      expandedKeys: {}
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSubmenuExpanded", function (key) {
      var subLinks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return function () {
        var _this$state$expandedK = _this.state.expandedKeys,
            expandedKeys = _this$state$expandedK === void 0 ? {} : _this$state$expandedK; // collapse submenu if already expanded, otherwise expand

        if (expandedKeys[key]) {
          delete expandedKeys[key]; // also collapse any expanded nested submenus

          subLinks.forEach(function (subLink) {
            delete expandedKeys[subLink.key];
          });
        } else {
          expandedKeys[key] = true;
        }

        _this.setState({
          expandedKeys: expandedKeys
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onNavItemClick", function () {
      var onClose = _this.props.onClose;

      if (typeof onClose === 'function') {
        onClose();
      }
    });

    return _this;
  }

  _createClass(CompactNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeKey = _this$props.activeKey,
          _this$props$links = _this$props.links,
          links = _this$props$links === void 0 ? [] : _this$props$links,
          DefaultLinkWrapper = _this$props.LinkWrapper,
          inverted = _this$props.inverted,
          rest = _objectWithoutProperties(_this$props, ["activeKey", "links", "LinkWrapper", "inverted"]);

      var _this$state$expandedK2 = this.state.expandedKeys,
          expandedKeys = _this$state$expandedK2 === void 0 ? {} : _this$state$expandedK2;
      return /*#__PURE__*/React.createElement("div", {
        className: "cloud-ui-nav compact trigger"
      }, /*#__PURE__*/React.createElement(NavDropdown, _extends({
        className: "cloud-ui-compact-nav",
        inverted: inverted,
        label: /*#__PURE__*/React.createElement("div", {
          className: "nav-icon-wrapper"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "menu"
        })),
        pinned: true,
        position: "bottom left",
        tooltip: "Navigation"
      }, rest), /*#__PURE__*/React.createElement("ul", {
        className: "cloud-ui-nav vertical compact"
      }, links.map(function (_ref) {
        var key = _ref.key,
            href = _ref.href,
            label = _ref.label,
            icon = _ref.icon,
            _ref$LinkWrapper = _ref.LinkWrapper,
            LinkWrapper = _ref$LinkWrapper === void 0 ? DefaultLinkWrapper : _ref$LinkWrapper,
            _ref$links = _ref.links,
            subLinks = _ref$links === void 0 ? [] : _ref$links,
            linkProps = _objectWithoutProperties(_ref, ["key", "href", "label", "icon", "LinkWrapper", "links"]);

        var hasSub = subLinks.length > 0;
        var subExpanded = !!expandedKeys[key];
        var isSubItemActive = hasSub ? !!subLinks.find(function (l) {
          return l.key === activeKey || (l.links || []).find(function (sl) {
            return sl.key === activeKey;
          });
        }) : false;
        return /*#__PURE__*/React.createElement("li", {
          key: key
        }, /*#__PURE__*/React.createElement(NavItem, _extends({}, linkProps, {
          href: href,
          icon: icon,
          isActive: isSubItemActive || activeKey === key,
          isOpen: subExpanded,
          LinkWrapper: LinkWrapper,
          onClick: hasSub ? _this2.toggleSubmenuExpanded(key, subLinks) : _this2.onNavItemClick
        }), /*#__PURE__*/React.createElement("span", {
          className: "label"
        }, label), hasSub && /*#__PURE__*/React.createElement(Icon, {
          className: "sub-arrow down",
          name: "chevron-down"
        })), subLinks && /*#__PURE__*/React.createElement("ul", {
          className: classNames('nav-sub-list', {
            hidden: !subExpanded
          })
        }, subLinks.map(function (_ref2) {
          var subKey = _ref2.key,
              subHref = _ref2.href,
              label = _ref2.label,
              _ref2$LinkWrapper = _ref2.LinkWrapper,
              SubLinkWrapper = _ref2$LinkWrapper === void 0 ? LinkWrapper : _ref2$LinkWrapper,
              _ref2$links = _ref2.links,
              subSubLinks = _ref2$links === void 0 ? [] : _ref2$links,
              subLinkProps = _objectWithoutProperties(_ref2, ["key", "href", "label", "LinkWrapper", "links"]);

          var hasSubSub = subSubLinks.length > 0;
          var subSubExpanded = !!expandedKeys[subKey];
          return /*#__PURE__*/React.createElement("li", {
            key: subKey
          }, /*#__PURE__*/React.createElement(NavItem, _extends({}, subLinkProps, {
            href: subHref,
            isActive: activeKey === subKey,
            LinkWrapper: SubLinkWrapper,
            isOpen: subSubExpanded,
            hasSub: hasSubSub,
            onClick: hasSubSub ? _this2.toggleSubmenuExpanded(subKey) : function () {
              var onClick = subLinkProps.onClick;

              if (typeof onClick === 'function') {
                onClick();
              }

              _this2.onNavItemClick();
            }
          }), label, subLinkProps.newTab && /*#__PURE__*/React.createElement(Icon, {
            name: "external-link-small"
          }), hasSubSub && /*#__PURE__*/React.createElement(Icon, {
            className: "sub-arrow down",
            name: "chevron-down"
          })), hasSubSub && /*#__PURE__*/React.createElement("ul", {
            className: classNames('nav-sub-list', {
              hidden: !subSubExpanded
            })
          }, subSubLinks.map(function (_ref3) {
            var subSubKey = _ref3.key,
                subSubLabel = _ref3.label,
                subHeading = _ref3.heading,
                _ref3$LinkWrapper = _ref3.LinkWrapper,
                SubSubLinkWrapper = _ref3$LinkWrapper === void 0 ? LinkWrapper : _ref3$LinkWrapper,
                subSubLinkProps = _objectWithoutProperties(_ref3, ["key", "label", "heading", "LinkWrapper"]);

            return /*#__PURE__*/React.createElement("li", {
              key: subSubKey
            }, /*#__PURE__*/React.createElement(NavItem, _extends({}, subSubLinkProps, {
              LinkWrapper: SubSubLinkWrapper,
              isActive: activeKey === subSubKey
            }), subSubLabel, subSubLinkProps.newTab && /*#__PURE__*/React.createElement(Icon, {
              name: "external-link-small"
            })));
          })));
        })));
      }))));
    }
  }]);

  return CompactNav;
}(React.Component);

var CompactNavWrapper = withNavDropdownEvents(CompactNav);
export default (function (props) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref4) {
    var activeKey = _ref4.activeKey,
        links = _ref4.links,
        hasLinks = _ref4.hasLinks,
        LinkWrapper = _ref4.LinkWrapper;
    return hasLinks ? /*#__PURE__*/React.createElement(CompactNavWrapper, _extends({}, props, {
      activeKey: activeKey,
      links: links,
      LinkWrapper: LinkWrapper
    })) : null;
  });
});